import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// Mapping table
const Construct_code_category = [
  { construct: "Self-Efficacy", code: "se", category: "Student Beliefs" },
  { construct: "Cognitive Engagement", code: "cog", category: "Learning Behaviors" },
  { construct: "Behavioral Engagement", code: "beh", category: "Learning Behaviors" },
  { construct: "Affective Engagement", code: "aff", category: "Learning Behaviors" },
  { construct: "Autonomy", code: "aut", category: "Classroom Context" },
  { construct: "Relatedness", code: "rel", category: "Classroom Context" },
  { construct: "Value", code: "val", category: "Student Beliefs" },
  { construct: "Self-Regulation", code: "srt", category: "Learning Behaviors" },
  { construct: "Intrinsic Motivation", code: "amot", category: "Student Beliefs" }, // or autonomous motivation? 
  { construct: "Extrinsic Motivation", code: "cmot", category: "Student Beliefs" }, // or controlled motivation?
  { construct: "Academic Burden", code: "bur", category: "Student Beliefs" },
  { construct: "Belongingness", code: "bel", category: "Classroom Context" }, // or perceived belonging?
  { construct: "Cultural Congruity", code: "cult", category: "Classroom Context" },
  { construct: "Withdrawal Intention", code: "with", category: "Learning Behaviors" },
];

// Category colors
const categoryColors = {
  "Student Beliefs": '#6A737B',
  "Learning Behaviors": '#AA6369',
  "Classroom Context": '#9BB6D2',
};

// Custom orders
const customOrders = {
    "Student Beliefs": [
        "Self-Efficacy",
        "Value",
        "Intrinsic Motivation",
        "Extrinsic Motivation",
        "Academic Burden"  
    ],
    "Learning Behaviors": [
        "Behavioral Engagement",
        "Cognitive Engagement",
        "Affective Engagement",
        "Self-Regulation",
        "Withdrawal Intention"
    ],
    "Classroom Context": [
        "Autonomy",
        "Relatedness",
        "Cultural Congruity",
        "Belongingness"
    ]
};

const GroupedBarChart = ({ questionAverage }) => {
  // Merge question stats w/ constructs and categories
    const merged = questionAverage.map((item) => {
        const meta = Construct_code_category.find((m) => m.code === item.group_code) || {};
        return {
        ...item,
        construct: meta.construct || item.group_code,
        category: meta.category || 'unknown',
        };
    });

    const categories = ['Student Beliefs', 'Learning Behaviors', 'Classroom Context'];

    const buildChartData = (category) => {
        const filtered = merged
            .filter((item) => item.category === category)
            .sort((a, b) => {
                const order = customOrders[category];
                return order.indexOf(a.construct) - order.indexOf(b.construct);
            });
        return {
            labels: filtered.map((item) => item.construct),
            datasets: [
                {
                    label: 'Average Score',
                    data: filtered.map((item) => item.avg_score),
                    backgroundColor: categoryColors[category] || '#999',
                    // barPercentage: 0.7,
                    // categoryPercentage: 0.9,
                    barThickness: 40,
                }
            ]
        };
    };

    const options = (category) => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const index = context.dataIndex;
                        // const item = merged[index];
                        const item = merged.find(i => i.construct === context.label);
                        return [
                            `Measure: ${item.construct}`,
                            `Mean: ${item.avg_score}`,
                            `Min: ${item.min_score}`,
                            `Max: ${item.max_score}`,
                            `Std: ${item.std_dev}`,
                        ]
                        // const construct = labels[index];
                        // const score = dataValues[index];
                        // return `${construct}: ${score}`;
                    },
                },
            },
        },
        layout: {
            padding: {
                top: 10,
                bottom: category === 'Learning Behaviors' ? 20 : 30,
                left: category === 'Student Beliefs' ? -8 : 0,
            },
        },
        scales: {
            y: {
                beginAtZero: false,
                min: 1,
                max: 6,
                ticks: {
                    stepSize: 1,
                    // callback: function(value) {
                    //     const labels = {
                    //         1: "Strongly Disagree 1",
                    //         2: "Disagree 2",
                    //         3: "Slightly Disagree 3",
                    //         4: "Slightly Agree 4",
                    //         5: "Agree 5",
                    //         6: "Strongly Agree 6",
                    //     };
                    //     return labels[value] || value;
                    // },
                    callback: category === 'Student Beliefs'
                        ? (value) => ({
                            1: "Strongly Disagree 1",
                            2: "Disagree 2",
                            3: "Slightly Disagree 3",
                            4: "Slightly Agree 4",
                            5: "Agree 5",
                            6: "Strongly Agree 6",
                        }[value] || value)
                        : (value) => value,
                }, 
                title: {
                    display: true,
                },
            },
            x: {
                ticks: {
                    autoSkip: false,
                    maxRotation: 60,
                    minRotation: 30,
                    padding: 8,
                },
            },
        },
    });

    // return (
    //     <div style={containerStyle}>
    //         {categories.map((cat) => (
    //             <div key={cat} style={chartWrapperStyle}>
    //                 <h3 style={headingStyle(categoryColors[cat])}>
    //                     {cat}
    //                 </h3>
    //                 <Bar data={buildChartData(cat)} options={options} />
    //             </div>
    //         ))}
    //     </div>
    // );
    return (
        <div style={containerStyle}>
            {categories.map((cat) => {
                const barCount = customOrders[cat]?.length || 1;
                return (
                <div key={cat} style={chartWrapperStyle(cat, barCount)}>
                    <h3 style={headingStyle(categoryColors[cat])}>
                        {cat}
                    </h3>
                    <Bar data={buildChartData(cat)} options={options(cat)} />
                </div>
                );
            })}
        </div>
    );
      
};

const containerStyle = {
    display: 'flex',
    gap: '2rem',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
    //overflowX: 'auto',
};

const baseWidthPerBar = 70;
const yLabelPadding = {
  "Student Beliefs": 100,     // More room for multi-word ticks
  "Learning Behaviors": 40,   // Regular numeric ticks
  "Classroom Context": 40,    // Regular numeric ticks
};

const chartWrapperStyle = (category, barCount) => ({
    flex: '0 0 auto',
    width: `${barCount * baseWidthPerBar + (yLabelPadding[category] || 40)}px`,
    height: '340px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  });

const headingStyle = (color) => ({
    color,
    textTransform: 'capitalize',
    textAlign: 'center',
});

export default GroupedBarChart;
